import { render, staticRenderFns } from "./SubcontractRequestsResolutionHandler.vue?vue&type=template&id=ffdbdd9a&"
import script from "./SubcontractRequestsResolutionHandler.vue?vue&type=script&lang=js&"
export * from "./SubcontractRequestsResolutionHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports